<script setup>
import {ref, useSlots} from "vue";

    const props = defineProps({
        slotTabs : {
            type: Array,
            default: () => []
        }
    })

    const slots = useSlots();

    const subTab = ref(props.slotTabs.length > 0 ? props.slotTabs[0].slotName : '');

    function toTitle(str) {
        return str.replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }
</script>

<template>
    <div class="space-y-4">

        <slot name="head" />

        <tabs :border="'border-b-none'" :custom-class="'bg-gray-100 p-2 rounded'">
            <template v-for="tab in slotTabs" :key="tab.slotName">
                <tab v-if="slots[tab.slotName]"
                     @click="subTab = tab.slotName"
                     :class="{ 'rounded bg-white': subTab === tab.slotName }"
                     :padding="'py-2 px-3'"
                >
                    {{ tab.tabTitle || toTitle(tab.slotName) }}
                </tab>
            </template>
        </tabs>

        <template v-for="tab in slotTabs" :key="tab.slotName">
            <template v-if="subTab === tab.slotName">
                <slot :name="tab.slotName" />
            </template>
        </template>

    </div>
</template>

